<script setup>
defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(value));
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลผู้ชำระ / ยูนิต</h5>
          <div class="text-muted small">
            ข้อมูลลูกบ้านและหน่วยที่ถูกเรียกเก็บ
          </div>
        </div>
        <div class="customer-avatar">
          <i class="bi bi-person-vcard"></i>
        </div>
      </div>

      <div class="mb-4">
        <div class="fw-bold fs-5">{{ invoice.residentName }}</div>
        <div class="text-muted">
          ยูนิต {{ invoice.unitCode }} • {{ invoice.building }}
        </div>
      </div>

      <div class="vstack gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">เลขที่ใบแจ้งหนี้</span>
          <span class="fw-semibold">{{ invoice.invoiceNo }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">รอบบิล</span>
          <span class="fw-semibold">{{ invoice.billingMonth }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">วันครบกำหนด</span>
          <span class="fw-semibold">{{ formatDate(invoice.dueDate) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.customer-avatar {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}
</style>
